<template>
  <header class="header-container">
    <!-- 🔥 Marquee Text -->
    <div class="marquee">
      <p>🚀 Cyber Security Championship 2026 – Registrations Open Now! 🚀</p>
    </div>

    <!-- Main Title -->
    <h1 class="main-title">Cyber Battle Arena 2026</h1>
  </header>
</template>

<script>
/* global fbq */
export default {
  name: "HeaderComponent",
  mounted() {
    if (!window.fbq) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

      fbq("init", "1161977425745681");
      fbq("track", "PageView");
    }
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nosifer&display=swap'); /* 🔥 Horror Dripping Font */

.header-container {
  width: 100%;
  background: linear-gradient(90deg, #0a0a0a, #1a0000);
  display: flex;
  flex-direction: column; /* 👈 title + marquee stacked */
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #e50914; /* red accent border */
  margin-top: -59px;
}

/* 🔥 MARQUEE STYLE */
.marquee {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background: linear-gradient(90deg, #e50914, #ff1e1e);
  color: #fff;
  font-weight: bold;
  padding: 0 0;
  border-radius: 4px;
  margin-bottom: 12px;
  box-shadow: 0 0 15px rgba(229, 9, 20, 0.6);
  font-family: 'Nosifer', cursive; /* same scary font */
}

.marquee p {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 12s linear infinite;
  font-size: 1rem;
}

@keyframes marquee {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}

/* Title */
.main-title {
  font-size: 3rem;
  font-weight: 900;
  text-transform: uppercase;
  font-family: 'Nosifer', cursive; /* 🔥 scary font */
  color: #ff1e1e;
  letter-spacing: 4px;
  text-align: center;
}

@media (max-width: 640px) {
  .main-title {
    font-size: 2rem;
    letter-spacing: 2px;
  }
  .marquee p {
    font-size: 0.9rem;
  }
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden; /* ❌ Horizontal scroll band */
  box-sizing: border-box;
  background-color: #000;
}

*,
*::before,
*::after {
  box-sizing: inherit;
  max-width: 100%;
}
</style>
